<template>
	<div :class="['sub-values']">
		<div v-if="data && data.text" class="sub-value clickable" @click="$emit('click')">
			<div v-html="data.text" />
		</div>
	</div>
</template>

<script>
import Label from "@/vue/characteristic/Label.vue";

export default {
	components: {Label},
	props: {
		data: {
			type: Object,
			required: false
		}
	}
}
</script>
